module.exports = __webpack_public_path__ + "img/expoglitter_0910_black_with_silver_glitters.a44409df.jpg";